import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { AdvtService } from '../../../_services/advt.service';
import { AlertService } from '../../../_services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, ResponseContentType } from '@angular/http';
import { Subscription } from 'rxjs/Subscription';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {Location} from '@angular/common';
import * as FileSaver from 'file-saver';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import 'rxjs/add/operator/toPromise';
import { RatingDialogComponent } from '../../../rating-dialog/rating-dialog.component';
import { NotificationsService} from 'angular2-notifications';


@Component({
  selector: 'app-free-history-detail',
  templateUrl: './free-history-detail.component.html',
  styleUrls: ['./free-history-detail.component.css']
})
export class FreeHistoryDetailComponent implements OnInit {

   
  @ViewChild("myVideo") public myVideo: any;
  @ViewChild("myAudio") public myAudio: any;
  @ViewChild("template") public template: TemplateRef<any>;
  @ViewChild("ratingtemplate") public ratingtemplate: TemplateRef<any>;
  @ViewChild("paymentModal") public paymentModal: TemplateRef<any>;
  @ViewChild("sellerModal") public sellerModal: TemplateRef<any>;
  @ViewChild("ratingdialog") public ratingdialog: TemplateRef<any>;
  
  modalRef: BsModalRef;
  private sub: Subscription;
  public _id;
  item_id;
  amount: any = '';
  buyer_id;
  seller_id;
  public listSingleItem;
  public itemVideoName;
  public itemAudioName;
  public itemImageName;
  public bidPost: Boolean = false;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  galleryImagesUser: NgxGalleryImage[];
  galleryMusic = [];
  placeholder: any;
  currentUser: any;
  showButton: Boolean = false;
  showdownloadbutton: Boolean = false;
  NAP;
  myTracks: any[];
  allTracks: any[];
  selectedTrack;
  ItemData;
  bidButton: Boolean = false;
  bidAmount;
  timeset;
  duration;
  control;
  MaxAmount;
  maxAmt;
  bid_Amount;
  mainLoader;
  loading: Boolean = false;
  modalText: String = '';
  UsersRating: Array<any> = [];
  UserRatingCount;
  pageSize = 5;
  pageNo = 1;
  ItemAvailable;
  imageData: any;


  
  purchaseImage;
  checkoutImage;
  chatImage;
  model = 3.5;
  itemData;
  tax_amount;
  tax = "3 %";
  payable_amount;
  amountCent;
  public payment_token;
  rating: number = 5;
  comment;
  RateData;
  status: Boolean = false;
  Ratestatus: Boolean = false;
  amt;
  emojiIcon;
  exchange;
  noVideo;
  ItemID;

  constructor(private advtService: AdvtService,
    private alertService: AlertService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private _location: Location,
    private http : Http,
    private sanitizer: DomSanitizer,
    private router: Router,
    private _NotificationsService: NotificationsService
    ) { }
    
    ngOnInit() {
      window.scrollTo(0,0);
      this.NAP = '../../assets/images/nap.jpg';
      this.noVideo = '../../assets/images/noVideo.png';
      this.mainLoader = '../../assets/images/BigLoader.gif';
      this.exchange = '../../assets/images/exchangetrade.png';
      const userInfo = JSON.parse(localStorage.getItem('currentUser'));
      this.currentUser = userInfo ? userInfo.result : null;
      this.buyer_id = userInfo.result ? userInfo.result.id : null;
      
      
      this.sub = this.route.params.subscribe((params) => {
        this._id = params['id'];
      });
      this.placeholder = '../../assets/images/pdf.png';
      
      
      this.getItemDetail();
      
      this.galleryOptions = [
        {
          width: '100%',
          height: '200px',
          thumbnailsColumns: 4,
          imageAnimation: NgxGalleryAnimation.Slide,    
          
        },
        // max-width 800
        {
          breakpoint: 800,
          width: '100%',
          height: '300px',
          imagePercent: 80,
          thumbnailsPercent: 20,
          thumbnailsMargin: 20,
          thumbnailMargin: 20,        
        },
        // max-width 400
        {
          breakpoint: 400,
          preview: false,        
        }
      ];
      if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 ) 
      {
        alert('Opera');
      }
      else if(navigator.userAgent.indexOf("Chrome") != -1 )
      {
        this.showdownloadbutton = false;
        //  alert('Chrome');
      }
      else if(navigator.userAgent.indexOf("Safari") != -1)
      { 
        this.showdownloadbutton = true;
      }
      else if(navigator.userAgent.indexOf("Firefox") != -1 ) 
      {
        this.showdownloadbutton = true;
        //alert('Firefox');
        //FileSaver.saveAs(audiourl, itemAudioName);
      }
      /*else if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true )) //IF IE > 10
      {
        alert('IE'); 
      } */ 
      else 
      {
      }
      
      
      
      
      
    }
    
    /**
    * 
    */
    public getItemDetail() {
      this.item_id = this._id;
      this.galleryImages = [];
      this.galleryImagesUser =[];          
      this.advtService.getFreeItemDetail(this.item_id)
      .subscribe(data => {
        this.ItemData = data;
        this.ItemID = data.item_id;
        this.showButton = data.showButton;
        if (data) {
          if(data.trade_item_meta){
            if (typeof data.trade_item_meta.images !== undefined) {
              if (data.trade_item_meta.images) {
                this.galleryImages = [];
                for (let i = 0; i < Object.keys(data.trade_item_meta.images).length; i++) {
                  if (typeof data.trade_item_meta.images[i] !== undefined) {
                    const csvArray = data.trade_item_meta.images[i];
                    this.galleryImages.push({
                      small: csvArray,
                      medium: csvArray,
                      big: csvArray
                    });
                  }
                }
              }
            }
          }
        } else {
          if (data.trade_item_meta.images) {
            this.galleryImages = [];
            for (let i = 0; i < Object.keys(data.trade_item_meta.images).length; i++) {
              if (typeof data.trade_item_meta.images[i] !== 'undefined') {
                const csvArray = data.trade_item_meta.images[i];
                this.galleryImages.push({
                  small: csvArray,
                  medium: csvArray,
                  big: csvArray
                });
              }
            }
          }
        }
        if (data) {
          if(data.item_meta){
            if (typeof data.item_meta.images !== undefined) {
              if (data.item_meta.images) {
                this.galleryImagesUser = [];
                for (let i = 0; i < Object.keys(data.item_meta.images).length; i++) {
                  if (typeof data.item_meta.images[i] !== undefined) {
                    const csvArray = data.item_meta.images[i];
                    this.galleryImagesUser.push({
                      small: csvArray,
                      medium: csvArray,
                      big: csvArray
                    });
                  }
                }
              }
            }
          }
          
        } else {
          if (data.item_meta.images) {
            this.galleryImagesUser = [];
            for (let i = 0; i < Object.keys(data.item_meta.images).length; i++) {
              if (typeof data.item_meta.images[i] !== 'undefined') {
                const csvArray = data.item_meta.images[i];
                this.galleryImagesUser.push({
                  small: csvArray,
                  medium: csvArray,
                  big: csvArray
                });
              }
            }
          }
        }
        
        this.listSingleItem = data;
        if(this.listSingleItem.trade_item_meta){
          if(this.listSingleItem.trade_item_meta.videos){
            this.itemVideoName = this.listSingleItem.trade_item_meta.videos.split("/")[5];
          }
        }
        
        // if(this.listSingleItem.meta.music !== undefined){
        //     this.itemAudioName = this.listSingleItem.meta.music[0].split("/")[5];
        // }
        // }
        
        this.bid_Amount = data.min_bid;
      }, error => {
        this.alertService.error(error);
      });
    }
    
    
    public saveFile(videourl,itemVideoName) {
      var ext =  videourl.substr(videourl.lastIndexOf('.') + 1);
      FileSaver.saveAs(videourl, itemVideoName);
    }
    
    public saveAudio(audiourl,itemAudioName) {
      FileSaver.saveAs(audiourl, itemAudioName); 
    }
    
    public saveImageFile(imageurl,itemImageName) {
      const newImageUrl =  imageurl.replace(/^https:\/\//i, 'http://');  
      this.http.get(newImageUrl, {
        responseType: ResponseContentType.Blob
      })
      .toPromise()
      .then((res: any) => {
        let blob = new Blob([res._body], {
          type: res.headers.get("Content-Type")
        });
        saveAs(blob, newImageUrl.split("/")[5]);
      });
      
      let url =imageurl; 
      if(imageurl){
        this.itemImageName = imageurl.split("/")[5];
      }
    }
    
    
    
    public saveAllImageFiles(imageurls) {
      let array = imageurls;
      for (let i = 0; i < array.length; i++) {
        const newImageUrl =  array[i].replace(/^https:\/\//i, 'http://');  
        this.http.get(newImageUrl, {
          responseType: ResponseContentType.Blob
        }).toPromise().then((res: any) => {
          let blob = new Blob([res._body], {
            type: res.headers.get("Content-Type")
          });
          saveAs(blob, newImageUrl.split("/")[5]);
        });
      };
    }
    
    /**
    * Function to open modal
    * @param template 
    */
    public openModal(template: TemplateRef<any>) {
      this.modalRef = this.modalService.show(
        template,
        Object.assign({}, { class: 'gray modal-md' })
        );
      }
      
      /**
      * function to Disbale Modal
      * @param event 
      */
      _hidemodal(event: any) {
        this.modalRef.hide();
      }
      
      backClicked() {
        this._location.back();
      }
      
      getAllRatingList(ratingtemplate: TemplateRef<any>) {
        this.modalText = 'Rating';
        // this.pageNo = (this.pageSize) - this.pageSize;
        const params = {
          seller_id: this.listSingleItem.seller_id,
          limit: 10000,
          offset: 0,
        };
        this.advtService.getRatingList(params).subscribe(data => {
          if (data.status === 200) {
            this.UsersRating = data.result;
            this.UserRatingCount = data.result.count;
          }
        });
        this.modalRef = this.modalService.show(
          ratingtemplate,
          Object.assign({}, { class: 'gray modal-md' })
          );
        }
        
        acceptRejectTrade(mode, id){
          let tempStatus;
          if(mode == "accept"){
            tempStatus = 2; // accept trade
          }else{
            tempStatus = 3; // decline trade
          }
          let param = {
            request_id: id,
            status:tempStatus
          };
          this.advtService.acceptRejectTrade(param).subscribe(data => {
            if (data.status === 200) {
              if(mode == 'accept'){
                this.alertService.success("Trade Accepted Successfully!");
                this.ngOnInit();
                // let ratingCheck = JSON.parse(localStorage.getItem('currentUser'));
                // ratingCheck.result.rating_pending = 1;
                // ratingCheck.result.rating_against_seller = tempID;
                // localStorage.setItem("currentUser", JSON.stringify(ratingCheck));
              }else{
                this.alertService.success("Trade Rejected Successfully!");
                this.ngOnInit();
              }
            }
          }, error => {
            this.alertService.error(error);
          });
        }
        
        openPayment(){
          this.openModal(this.paymentModal);
        }
        
        calculateTax(){
          
          let tax = 3 //  three percent 
          this.tax_amount = ((parseFloat(this.amt) *(tax)) / 100)
          if(isNaN(this.tax_amount)){
            this.tax_amount = 0;
          }
          this.payable_amount = ((this.amt - 0) + (parseFloat(this.tax_amount) - 0));
          this.amountCent =parseFloat(this.payable_amount);

          if(isNaN(this.amountCent)){
            this.amountCent = 0;
          }
        }
        
        
        /*
        * PAYMENT method
        */
        openCheckout() {
          this.modalRef.hide();
          var handler = (<any>window).StripeCheckout.configure({
            key: 'pk_test_8qFDtezJbEFFBjestSU6TaFO00HPPmu2Tx',
            locale: 'auto',
            token: (token: any) => { this.createOrder(token.id); }
          });
          handler.open({
            name: 'Bidjones',
            image:'../../assets/images/logo.png',
            // description: 'abc',
            // amount: this.amountCent
          });
        }
        
        /**
        * 
        * @param token token generated during the transaction 
        */
        createOrder(token) {

          let tempID;
          if(this.ItemData.receiver_id == this.buyer_id){
            tempID = this.ItemData.trade_item_id;
          }else if(this.ItemData.sender_id == this.buyer_id){
            tempID = this.ItemData.item_id
          }
          this.loading = true;
          const params = {
            buyer_id: this.buyer_id,
            amount: this.amountCent,
            item_id: tempID,
            payment_token: token
          }
          this.advtService.getPaymentToken(token, params).subscribe(res => {
            if (res.status === 200) {
              this.updatePayment();
              this.status = true;
              this.alertService.success("Payment Successfully done.");
              this.ngOnInit();
              // this.router.navigate(['/dashboard']);
              this.loading = false;
            } else {
              this.status = false;
            }
          });
        }

        // openRating(){
        //  let  config = { backdrop: true, ignoreBackdropClick: false , keyboard: false };
        //   this.modalRef = this.modalService.show(RatingDialogComponent, config);
        // }
        
        updatePayment(){
          let paymentSender, paymentReciever;
          if(this.ItemData.receiver_id == this.buyer_id){
            paymentSender = this.ItemData.receiver_id;
            paymentReciever = this.ItemData.sender_id;
          }else if(this.ItemData.sender_id == this.buyer_id){
            paymentSender = this.ItemData.sender_id;
            paymentReciever = this.ItemData.receiver_id;
          }
          let param = {
            trade_id : this._id,
            amount :this.amountCent,
            payment_sender: paymentSender,
            payment_receiver: paymentReciever
          }
          this.advtService.updatePayment(param).subscribe(data => {
            if (data) {
               this.ngOnInit();
            }
          }, error => {
            this.alertService.error(error);
          });
        }
        
        _checkNumPattern(event: any) {
          const pattern = /[0-9\+\.\ ]/;
          if (event.which === 32 && event.target.selectionStart === 0) {
            return false;
          }
          if (event.which === 48 && event.target.selectionStart === 0) {
            return false;
          }
          let inputChar = String.fromCharCode(event.charCode);
          if (!pattern.test(inputChar)) {
            event.preventDefault();
          }
        }



        _disposeModal(){
          this.modalRef.hide()
        }

        openRating(){
          this.emojiCheck();  
          this.openModal(this.ratingdialog);
        }
      
        public rateSeller(currentUser) {
          let tempID;
          if(this.ItemData.receiver_id == this.buyer_id){
            tempID = this.ItemData.sender_id;
          }else if(this.ItemData.sender_id == this.buyer_id){
            tempID = this.ItemData.receiver_id
          }
            if(this.currentUser){
              this.loading = true;
              const params = {
                buyer_id: this.currentUser.id,
                item_id: this.ItemID,
                seller_id: tempID,
                rating: this.rating ? this.rating : 5,
                comment: this.comment,
              }
              this.advtService.rateSeller(params).subscribe(res => {
               if(res.status == 200){
                this._NotificationsService.success(res.message)
                 this.comment = "";
                let ratingCheck = JSON.parse(localStorage.getItem('currentUser'));
                ratingCheck.result.rating_pending = 0;
                ratingCheck.result.rating_against_seller = 0;
                localStorage.setItem("currentUser", JSON.stringify(ratingCheck));
                // this.router.navigate(['/dashboard']);
               }
               else{
                 this._NotificationsService.warn(res.message)
               }
               });
            }
      
      
           this._disposeModal();
          this.loading = false;
      
        }
      
        public emojiCheck(){
          if(this.rating === 1 ){
            this.emojiIcon = '../assets/images/one.png';
          }else if(this.rating === 2){
            this.emojiIcon = '../assets/images/two.png';
          }else if(this.rating === 3){
            this.emojiIcon = '../assets/images/three.png';
          }else if(this.rating === 4){
            this.emojiIcon = '../assets/images/four.png';
          }else if(this.rating === 5){
            this.emojiIcon = '../assets/images/five.png';
          }
        }
        

}



// WEBPACK FOOTER //
// ./src/app/authorized-data/free/free-history-detail/free-history-detail.component.ts